<!-- 设备设施养护 -->
<template>
    <div class='page_content'>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"
                @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform"
                    :getRequestData="getRequestData" @searchData="searchData" @openSearchs="openSearch">
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight"
                :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
                <el-table-column align="center" label="选择操作" width="80">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column align="center" v-if="tableValye.isShow == 1"
                    v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
                    show-overflow-tooltip :prop="tableValye.entityField" :min-width="tableValye.fieldWeight"
                    :label="tableValye.showField">
                    <template slot="header">
                        <div>
                            <el-tooltip :content="tableValye.showField" placement="top">
                                <div class="long_title"><span :ref="tableValye.entityField">{{ tableValye.showField
                                        }}</span></div>
                            </el-tooltip>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                            {{ scope.row.isWms == 0 ? '否' : '是' }}
                        </el-tag>
                        <el-tag size="mini" v-else-if="tableValye.entityField == 'psomState'">
                            {{ $common.getIsGsp(tableValye.formatterContent, scope.row.psomState) }}</el-tag>
                        <span v-else-if="tableValye.entityField == 'psomBuydate'">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                        </span>
                        <span v-else-if="tableValye.entityField == 'emcDate'">
                            <span v-if="scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                        </span>
                        <!-- <span v-else-if="tableValye.entityField == 'psomId'">
                        <a @click="toDetail(scope.row)">{{scope.row[tableValye.entityField]}}</a>
                    </span> -->
                        <span v-else>
                            {{ scope.row[tableValye.entityField] }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
                @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <el-drawer :close-on-press-escape="true" :title="diaType == 0 ? '新增' : '修改'" :visible.sync="dialogAdd"
            :with-header="false" :append-to-body="true" :direction="'ltr'" size="100%">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
                    <v-tabs :type="diaType" :activeName="diaType == 0 ? '新增设备设施养护' : '修改设备设施养护'" :name="'jciName'"
                        :value="'jciName'" :tabslist="formDataList.jurconfigform" @tabs="(val) => { showTabs = val }">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form :model="sendDataInfo" id="mainInfo" class="baseForm" label-width="120px"
                                        ref="sendDataInfo" :show-message="false">
                                        <el-row v-if="diaType == 0">
                                            <el-form-item
                                                v-for="(formOneValue, formOneKey) in formDataList.jurconfigform"
                                                :key="formOneKey"
                                                v-if="formOneValue.entityField != 'fmName' && formOneValue.isShow == 1"
                                                :label="formOneValue.showField" :prop="formOneValue.entityField"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                                    v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                <df-date :isdisabled="formOneValue.isChange == 0"
                                                    v-if="formOneValue.fieldType == 'date'"
                                                    v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                <!-- 设备名称 -->
                                                <el-input v-else-if="formOneValue.entityField == 'fmName'"
                                                    @focus="openSearch(formOneValue.searchId, 0, 'fmName')"
                                                    v-model="sendDataInfo[formOneValue.entityField]" clearable>
                                                    <el-button @click="openSearch(formOneValue.searchId, 0, 'fmName')"
                                                        slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                                <!-- 养护人 -->
                                                <el-input v-else-if="formOneValue.entityField == 'emcPerson'"
                                                    @focus="openSearch(formOneValue.searchId, 0, 'emcPerson')"
                                                    v-model="sendDataInfo[formOneValue.entityField]" clearable>
                                                    <el-button
                                                        @click="openSearch(formOneValue.searchId, 0, 'emcPerson')"
                                                        slot="append" icon="el-icon-search"></el-button>
                                                </el-input>
                                                <!-- 养护措施 -->
                                                <el-select v-else-if="formOneValue.entityField == 'emcMeasures'"
                                                    v-model="sendDataInfo[formOneValue.entityField]" multiple
                                                    collapse-tags placeholder="请选择养护措施">
                                                    <el-option v-for="(item, index) in wayList" :key="index"
                                                        :value="item.diValue" :label="item.diValue"></el-option>
                                                </el-select>
                                                <el-input v-else-if="formOneValue.entityField == 'emcConclusion'"
                                                    type="textarea" v-model="sendDataInfo[formOneValue.entityField]"
                                                    clearable></el-input>
                                                <el-input v-else v-model="sendDataInfo[formOneValue.entityField]"
                                                    clearable></el-input>
                                            </el-form-item>
                                        </el-row>
                                        <el-row v-if="diaType == 1">
                                            <el-form-item v-if="formOneValue.isShow == 1"
                                                v-for="(formOneValue, formOneKey) in formDataList.jurconfigform"
                                                :key="formOneKey" :label="formOneValue.showField"
                                                :prop="formOneValue.entityField"
                                                :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                <df-date :isdisabled="formOneValue.isChange == 0"
                                                    v-if="formOneValue.fieldType == 'date'"
                                                    v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                <!-- 设备名称 -->
                                                <el-input v-else-if="formOneValue.entityField == 'fmName'"
                                                    @focus="openSearch(formOneValue.searchId, 0, 'fmName')"
                                                    v-model="sendDataInfo[formOneValue.entityField]"
                                                    clearable></el-input>
                                                <!-- 养护人 -->
                                                <el-input v-else-if="formOneValue.entityField == 'emcPerson'"
                                                    @focus="openSearch(formOneValue.searchId, 0, 'emcPerson')"
                                                    v-model="sendDataInfo[formOneValue.entityField]"
                                                    clearable></el-input>
                                                <!-- 养护措施 -->
                                                <el-select v-else-if="formOneValue.entityField == 'emcMeasures'"
                                                    v-model="sendDataInfo[formOneValue.entityField]" multiple
                                                    collapse-tags placeholder="请选择养护措施">
                                                    <el-option v-for="(item, index) in wayList" :key="index"
                                                        :value="item.diValue" :label="item.diValue"></el-option>
                                                </el-select>
                                                <el-input v-else-if="formOneValue.entityField == 'emcConclusion'"
                                                    type="textarea" v-model="sendDataInfo[formOneValue.entityField]"
                                                    clearable></el-input>
                                                <el-input v-else v-model="sendDataInfo[formOneValue.entityField]"
                                                    clearable></el-input>
                                            </el-form-item>
                                        </el-row>
                                    </el-form>
                                    <!-- 明细信息 -->
                                    <el-form v-if="diaType == 0" :inline="true" size="mini">
                                        <div id="operateBtn">
                                            <el-button @click="openExtSearch('253286358061056')" size="mini"
                                                type="primary">选择设备</el-button>
                                            <el-button type="danger" size="mini"
                                                @click="deleteDetails()">删除一行</el-button>
                                        </div>
                                        <el-table size="mini" class="baseTable" :data="dataInfolist" ref="mxTableRef"
                                            :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                            @selection-change="handleSelectionChange" border :height="mxHeight">
                                            <el-table-column align="center" label="选择操作" min-width="80">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index"
                                                        border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <el-table-column align="center" label="设备ID" min-width="150"
                                                prop="fmId"></el-table-column>
                                            <el-table-column align="center" label="设备编号" min-width="150"
                                                prop="fmCode"></el-table-column>
                                            <el-table-column align="center" label="设备名称" min-width="150" prop="fmName"></el-table-column>
                                            <el-table-column align="center" label="规格" min-width="150" prop="spec"></el-table-column>
                                            <el-table-column align="center" label="生产厂商" min-width="150" prop="manufacturer"></el-table-column>
                                            <el-table-column align="center" label="存放位置" min-width="150" prop="stLocation"></el-table-column>
                                        </el-table>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <div class="foot">
                    <el-button @click="dialogAdd = false">取 消</el-button>
                    <el-button type="primary" @click="diaConfirm">确 定</el-button>
                </div>
            </div>
        </el-drawer>
        <el-dialog :title="seTitle" v-if="DialogVisible1" :visible.sync="DialogVisible1" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchSchemeMultiple ref="searchSchemeMultiple" :id="searchId" :parentData="parentData"
                :parentSearchData="parentSearchData" @TranData="changeInputModel" @selection="selection"
                @getWidth="getSeWidth" @sendTitle="getSearchName" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="DialogVisible1 = false">取 消</el-button>
                <el-button type="primary" @click="getSelect">确认选择</el-button>
            </span>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import ExtractionScheme from "../../../byComponents/ExtractionScheme.vue";
import SearchSchemeMultiple from "../../../byComponents/SearchSchemeMultiple.vue";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        ExtractionScheme,
        SearchSchemeMultiple
    },
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {
                fmName: '',
                page: 1,
                rows: 30,
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
                fmId: ''
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: []
            },
            sendDataInfo: {
                "emcConclusion": "",
                "emcDate": 0,
                "emcId": 0,
                "emcMeasures": [],
                "emcPerson": "",
                "emcReason": "",
                "emcState": 0,
                "fmCode": "",
                "fmId": 0,
                "fmName": ""
            },
            mxHeight: 0,
            dialogAdd: false,
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            selectedDataIndex: 0,
            exId: "",
            seId: "",
            ceshi: "",
            dialogTitle: "",
            seWidth: "",
            height: "",
            exTitle: "",
            seTitle: "",
            seWidth: "",
            exWidth: "",
            DialogVisible: false,
            DialogExtract: false,
            seType: '',
            smId: '',
            sField: "",
            diaType: 0,
            wayList: [],
            parentSearchData: {},
            parentData: {
                type: "fmId",
                list: [],
            },
            dataInfolist: [],//设备名称组
            selectedDetailsIndex: 0,
            selectedRow: [],
            //-------------------------
            DialogVisible1: false,
            selectelist: [],
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        'getRequestData.fmName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.getRequestData.fmId = ''
                }
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        //触发提取
        openExtSearch(searchId) {
            this.searchId = searchId
            if (this.dataInfolist.length > 0) {
                this.parentData.list = this.dataInfolist
            }
            this.DialogVisible1 = true;
        },
        selection(val) {
            this.selectelist = val
        },
        getSelect() {
            this.dataInfolist = this.selectelist
            this.DialogVisible1 = false;
        },
        // 表格方法
        rowClassName({
            row,
            rowIndex
        }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        // 选中行底色逻辑
        rowStyle({
            row,
            rowIndex
        }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },
        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            this.selectedDetailsIndex = row.rowIndex;
        },
        deleteDetails() {
            if (this.dataInfolist.length < 1) {
                return this.$message({
                    message: "暂无可删除明细",
                    type: "warning",
                });
            }
            this.dataInfolist.splice(this.selectedDetailsIndex, 1);
            if (this.dataInfolist.length > 1) {
                this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1);
            } else {
                this.selectedDetailsIndex = 0;
            }
        },

        toDetail(row) { },
        changeInputModel(val) {
            console.log(val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.seType == 'fmId') {
                    this.getRequestData.fmName = val.fmName
                    this.getRequestData.fmId = val.fmId
                } else if (this.seType == 'fmName') {
                    if (this.diaType == 1) {
                        for (let key in val) {
                            this.sendDataInfo[key] = val[key]
                        }
                    } else {
                        if (this.dataInfolist.length == 0) {
                            this.dataInfolist = [val]
                        } else {
                            var arr = [val]
                            this.dataInfolist.forEach(item => {
                                arr.forEach((item1, index) => {
                                    if (item1.fmId == item.fmId) {
                                        arr.splice(index, 1)
                                    }
                                })
                            })
                            this.dataInfolist = this.dataInfolist.concat(arr)
                        }
                    }
                } else if (this.seType == 'emcPerson') {
                    this.sendDataInfo.emcPerson = val.opmName
                } else {
                    this.paramValue(val)
                }
            }
        },
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        getExtractName(e) {
            console.log(e);
            this.exTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.seType = type
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            if (type == 'emcPerson') {
                this.parentSearchData = {
                    opmBuyer: ''
                }
            }
        },
        isShowData(name, value) {
            switch (name) {
                case 'supplier':
                    var dataInfo = sessionStorage.getItem('selectSupplierData')
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo)
                        this.getRequestData.psomBuycus = dataInfo.smId
                        this.getRequestData.smName = dataInfo.smName
                    }
                    break;
            }
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                this.formDataList = this.pageShowData.jurFormVoList[0]
                this.getButtonList()
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        init() {
            for (let key in this.sendDataInfo) {
                if (key == 'emcMeasures') {
                    this.sendDataInfo[key] = []
                }else {
                    this.sendDataInfo[key] = ''
                }
            }
            this.dataInfolist=[]
        },
        async sub() {
            this.sendDataInfo.emcMeasures = this.sendDataInfo.emcMeasures.toString()
            if (this.diaType == 0) {
                if (this.dataInfolist.length == 0) {
                    return this.$message.error("请选择设备");
                }
                this.sendDataInfo.fmId = [];
                this.dataInfolist.forEach(item => {
                    this.sendDataInfo.fmId.push(item.fmId)
                })
                var responseData = await this.$http.addGspYhInfo(this.sendDataInfo)
            } else {
                var responseData = await this.$http.updateGspYhInfo(this.sendDataInfo)
            }
            if (responseData.status == 200) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.dialogAdd = false
                this.getDataList()

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        diaConfirm(sendDataInfo) {
            this.$refs['sendDataInfo'].validate((valid) => {
                if (valid) {
                    this.sub()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        openAddDia(e) {
            if (e == 0) {
                this.diaType = 0
                this.init()
            } else {
                this.diaType = 1
                var dataInfo = this.returnData.list[this.selectedDataIndex]
                if (!dataInfo) {
                    this.$message({
                        message: '请先选中要操作的数据',
                        type: 'error'
                    });
                    return false
                }
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                }
                this.sendDataInfo.emcMeasures = this.sendDataInfo.emcMeasures.split(',')
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.diaType != 2) {
                        this.mxHeight = this.$common.getBtnHeight() - 10
                    } else {
                        this.mxHeight = this.$common.getHeight() - 10
                    }
                }, 16.7)
            });
            this.dialogAdd = true
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType, 'actionData.actionType');

            switch (actionData.actionType) {
                case 0:
                    this.openAddDia(0)
                    // this.$refs['emcuringListAction'].openBox(0,this.formDataList,'','')
                    break;
                case 1:

                    this.openAddDia(1)
                    // this.$refs['emcuringListAction'].openBox(1,this.formDataList,'',dataInfo)
                    break;
                case 2:
                    this.delDataAction()
                    break;
                case 3:
                    this.submitDataAction()
                    break;
                case 88:
                    this.showPrintPlan()
                    break
                case 15:
                    this.openFormDesign()
                    break;

            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        showPrintPlan() {
            var dataInfo = this.returnData.list[this.selectedDataIndex];
            if (!dataInfo) {
                this.$message({
                    message: "请先选中要操作的数据",
                    type: "error",
                });
                return false;
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(dataInfo.emcId, sessionStorage.getItem('printSource').replace(/\"/g, ""), sessionStorage.getItem('printJurId'))
            } else {
                return
            }
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getGspYhList(this.getRequestData)
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list
                this.returnData.pages = responseData.result.pages
                this.returnData.total = responseData.result.total
                this.returnData.pageNum = responseData.result.pageNum
                this.selectedDataIndex = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 删除数据
        delDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }

            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.emcId]
                }
                let responseData = await this.$http.delGspYhInfo(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });

                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => { });
        },

        // 提交审核
        submitDataAction() {
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }

            this.$confirm('确定要提交审核?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.psomId]
                }
                let responseData = await this.$http.submitPurchaseOrder(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '操作成功'
                    });

                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }

            }).catch(() => { });
        },
        //获取状态
        getIsGsp(str, val) {
            try {
                str && str.replace(/\\/g, '')
                let arr = JSON.parse(str)
                let len = arr.length
                let newStr = ''
                for (let i = 0; i < len; i++) {
                    if (arr[i].key === val) {
                        newStr = arr[i].value
                        break;
                    }
                }
                return newStr
            } catch (ex) {
                return str
            }
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
// 获取国家
        async getWay() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [19]
            })
            if (responseData.status == 200) {
                if (responseData.result.yhcs) {
                    this.wayList = responseData.result.yhcs
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },



    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()

        this.getWay()

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-drawer {
    outline: none;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
}
</style>